export default __webpack_public_path__ + "static/media/docx.1990540f.png";